import { axiosApi } from "services/api";


export const getBrandCampaigns = async ({ token, data, page }) => {
    try {
        const response = await axiosApi.post(`/filter/my/campaign?page=${page}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data; // Assuming the response data is directly in `data`
    } catch (error) {
        throw error; // Throw the error to be handled by the action/reducer
    }
};